import { render, staticRenderFns } from "./RaceDetail.vue?vue&type=template&id=75496a21&"
import script from "./RaceDetail.vue?vue&type=script&lang=js&"
export * from "./RaceDetail.vue?vue&type=script&lang=js&"
import style0 from "./RaceDetail.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VContainer,VSkeletonLoader})
